module.exports = __webpack_public_path__ + "static/media/TN.a2224f31.png";